(function () {
  const KEY_PREFIX = 'cdh_scroll_';

  function isHomePage() {
    return window.location.pathname === '/';
  }

  function getPageKey() {
    return KEY_PREFIX + window.location.pathname + window.location.search;
  }

  function isBackForwardNavigation(event) {
    if (event && event.persisted) return true; // página servida desde bfcache (navegación atrás/adelante)

    if (window.performance && typeof performance.getEntriesByType === 'function') {
      const entries = performance.getEntriesByType('navigation');
      if (entries && entries[0]) {
        return entries[0].type === 'back_forward';
      }
    }

    if (window.performance && performance.navigation) {
      return performance.navigation.type === 2; // TYPE_BACK_FORWARD (API antigua, respaldo)
    }

    return false;
  }

  function saveScroll() {
    if (isHomePage()) return; // el home siempre debe arrancar arriba, nunca se guarda su posición
    sessionStorage.setItem(getPageKey(), String(window.scrollY));
  }

  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href]');
    if (!link) return;

    const href = link.getAttribute('href');

    if (
      href &&
      (href.includes('/products/') || link.closest('.card-wrapper, .product-card, .grid__item'))
    ) {
      saveScroll();
    }
  });

  window.addEventListener('beforeunload', saveScroll);

  window.addEventListener('pageshow', function (event) {
    if (isHomePage()) return; // nunca restaura scroll en el home
    if (!isBackForwardNavigation(event)) return; // solo restaura al volver con "Atrás"; nunca en clics hacia adelante (ej. paginación)

    const savedY = sessionStorage.getItem(getPageKey());

    if (savedY !== null) {
      setTimeout(function () {
        window.scrollTo({
          top: parseInt(savedY, 10),
          behavior: 'instant'
        });
      }, 80);
    }
  });
})();